export interface AddressType {
  streetname?: string;
  addressline1: string;
  addressline2: string;
  city: string;
  county: string;
  postcode: string;
  uprn: string;
  usrn: string;
  fullAddress?: string;
  latitude?: string;
  longitude?: string;
  easting?: string;
  northing?: string;
  country?: string;
}

export type AddressResponse = {
  address_line_1: string;
  address_line_2: string;
  town: string;
  county: string;
  postcode: string;
  country: string;
  UPRN: string;
  USRN: string;
  latitude: string;
  longitude: string;
  full_address: string;
};

export interface ServiceLocationDetailsObjectType {
  address_line_1: string;
  address_line_2: string;
  country: string;
  county: string;
  easting: string | null;
  latitude: number | null;
  longitude: number | null;
  northing: string | null;
  postcode: string;
  town_city: string;
  UPRN: string;
  USRN: string;
  full_address?: string;
}

// fill in mock data for testing -> to remove in production
export const emptyServiceLocationDetails = {
  address_line_1: '',
  address_line_2: '',
  country: '',
  county: '',
  easting: null,
  latitude: null,
  longitude: null,
  northing: null,
  postcode: '',
  town_city: '',
  UPRN: '',
  USRN: '',
};
